export const DELIVERY_TYPE_REQUIRED_MESSAGE = 'Type is required.';
//# sourceMappingURL=delivery-type-required-message.js.map